<template>
    <div class="w-full flex justify-center items-center">
        <a      v-if="href !== ''"
                :href="href"
                :class="'plain-link-white ' + baseClass"
        ><slot></slot></a>

        <button     v-else
                    :class="baseClass"

        ><slot></slot></button>
    </div>
</template>

<script>

export default {
    name: "GreenButton",
    mixins: [],
    components: {},
    props: {
        href: {
            type: String,
            default: '',
        },
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
    },
    computed: {
        baseClass() {
            return `w-full relative px-4 py-2 border border-transparent text-sm text-center leading-5 font-medium
                    rounded-md text-white bg-green-600 hover:bg-green-400 focus:outline-none focus:shadow-outline-green
                    focus:border-green-400 active:bg-green-400 cursor-pointer`
        }
    },
    watch: {

    },
}
</script>

<style scoped>

</style>